/** @format */

import React from "react";

//header
import Header from "../../components/partials/dashboard/HeaderStyle/emp-header";

//sidebar
import RightSidebar from "../../components/partials/dashboard/SidebarStyle/rightsidebar";

//sidebar
import Sidebar from "../../components/partials/dashboard/SidebarStyle/emp-sidebar";

//footer
import Footer from "../../components/partials/dashboard/FooterStyle/footer";

//settingoffCanvas
import SettingOffCanvas from "../../components/setting/SettingOffCanvas";
import { Navigate, Outlet } from "react-router-dom";
import * as RoleSelector from "src/store/role/selector";
import { useAppSelector } from "../../store/hook";

const EmployerLayout = () => {
  const role = useAppSelector(RoleSelector.selectUserRole);

  if (role != "employer") {
    return <Navigate replace to={"/error/error404"} />;
  }
  return (
    <>
      <Sidebar />
      <div className="main-content">
        <div className="position-relative">
          <Header />
          {/* <Views /> */}
          <Outlet />
        </div>
      </div>
      <RightSidebar />
      <Footer />
      <SettingOffCanvas />
    </>
  );
};

export default EmployerLayout;
